import Vue from 'vue';
import Vue2Filters from 'vue2-filters'
import moment from 'moment'
import _ from 'lodash'

var Vue2FiltersConfig = {
  currency: {
    symbol: 'R$',
    decimalDigits: 2,
    thousandsSeparator: '.',
    decimalSeparator: ',',
    spaceBetweenAmountAndSymbol: true
  },
};
Vue.use(Vue2Filters, Vue2FiltersConfig)

const brandNameByCode = function(brand) {
  const brandCode = _.isObject(brand) ? brand.Code : brand;
  switch (brandCode) {
    case '1': return "Visa";
    case '2': return "Master";
    case '3': return "Amex";
    case '9': return "JCB";
    case '10': return "Diners";
    case '11': return "Discover";
    default:  return "Outros";
  }
}

const backgroundCheckStatus = function(backgroundCheck) {
  const status = _.isObject(backgroundCheck) ? backgroundCheck.Status : backgroundCheck;
  switch (status) {
    case 0: return "Aguardando Onboard";
    case 1: return "Aprovado";
    case 2: return "Reprovado";
    default:  return "Desconhecido";
  }
}

const brandIconByCode = function(brand) {
  const brandCode = _.isObject(brand) ? brand.Code : brand;
  switch (brandCode) {
    case '1': return "fab fa-cc-visa";
    case '2': return "fab fa-cc-mastercard";
    case '3': return "fab fa-cc-amex";
    case '9': return "fab fa-cc-jcb";
    case '10': return "fab fa-cc-diners-club";
    case '11': return "fab fa-cc-discover";
    default:  return "fas fa-credit-card";
  }
}

Vue.filter('orderBy', function (array, sortBy) {
  if (array == null || array == undefined)
    return array;
  if (array) {
    return _.orderBy(array, sortBy);
  }
});

Vue.filter('addDay', function (value, number) {
  if (value == null || value == undefined)
    return value;
  if (value) {
    let dayAdd = value.setDate(value.getDate() + number);
    let dayDate = new Date(dayAdd);
    return dayDate.toJSON().substring(0, 10);
  }
});

Vue.filter('addMonth', function (value, number) {
  if (value == null || value == undefined)
    return value;
  if (value) {
    let monthAdd = value.setMonth(value.getUTCMonth() + number);
    let monthDate = new Date(monthAdd);
    return monthDate.toJSON().substring(0, 10);
  }
});

Vue.filter('firstDayOfMonth', function (value, format = 'DD/MM/YYYY') {
  if (value == null || value == undefined)
    return value;
  if (value) {
    let date = new Date(value.getUTCFullYear(), value.getUTCMonth(), 1);
    return moment(date).format(format);
  }
});

Vue.filter('lastDayOfMonth', function (value, format = 'DD/MM/YYYY') {
  if (value == null || value == undefined)
    return value;
  if (value) {
    let date = new Date(value.getUTCFullYear(), value.getUTCMonth() + 1, 0);
    return moment(date).format(format);
  }
});

Vue.filter('date', function (value, format = 'DD/MM/YYYY') {
  if (value == null || value == undefined)
    return value;
  if (value) {
    return moment(value).format(format)
  }
});

Vue.filter('monthYear', function (value) {
  if (value == null || value == undefined)
    return value;
  if (value) {
    let date = new Date(value);
    return date.getMonthName() + `/${date.getUTCFullYear()} `;
  }
});

Vue.filter('hourMinute', function (value) {
  var hour = Math.floor(value / 60);
  var min = value % 60;
  min = min < 10 ? '0' + min : min;
  return `${hour > 0 ? hour + 'h ' : ''}${min > 0 ? min + ' min' : ''}`;
});

Vue.filter('lower', function (value) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  return value.toLowerCase();
});

Vue.filter('upper', function (value) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  return value.toUpperCase();
});

Vue.filter('capitalizeFirstLetter', function (value) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  value = value.toLowerCase();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('capitalizeWords', function (value) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  return value.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase(); });
});

Vue.filter('split', function (value, separator) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  let valueSplit = value.split(separator);
  if (valueSplit == null || valueSplit == undefined || valueSplit.length == 0)
    return value;
  return valueSplit[0];
});

Vue.filter('substring', function (value, length) {
  if (value == null || value == undefined || value.length == 0 || value.length < (length - 1))
    return value;
  return value.substring(0, length - 1);
});

Vue.filter('ellipsis', function (value, length) {
  if (value == null || value == undefined || value.length == 0 || value.length < (length - 1))
    return value;
  return value.substring(0, length - 1) + '...';
});

Vue.filter('identity', function (value, cpf = undefined) {
  {
    if (value == null || value == undefined || value.length == 0)
      return value;
    let identity = value.replace(/[^\d]/g, "");
    if ((cpf == undefined && identity.length == 11) || (cpf != undefined && cpf))
      return identity.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    if ((cpf == undefined && identity.length == 14) || (cpf != undefined || !cpf))
      return identity.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    return identity;
  }
});

Vue.filter('phone', function (value) {
  {
    if (value == null || value == undefined || value.length == 0)
      return value;
    var phone = value.replace(/[^\d]/g, "");
    if (phone.length == 8) {
      phone = phone.replace(/(\d{4})(\d{4})/, "$1-$2");
    } else if (phone.length == 9) {
      phone = phone.replace(/(\d{5})(\d{4})/, "$1-$2");
    }
    else if (phone.length == 10) {
      phone = phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    }
    else if (phone.length == 11) {
      phone = phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    }
    return phone;
  }
});

Vue.filter('breakline', function (value) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  return value.replace(/(?:\r\n|\r|\n)/g, '<br/>');
});

var numeral = require("numeral");
Vue.filter("number", function (value) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  return numeral(value).format("0,0").replace(',', '.');
});

Vue.filter("regexNumber", function (value) {
  if (value == null || value == undefined)
    return value;
  return value.replace(/[^\d]/g, "");
});

Vue.filter("percentage", function (value) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  let valueFloat = parseFloat(value);
  return valueFloat.toFixed(2).concat('%').replace('.', ',');
});

Vue.filter('showValidateError', function (showError, invalid) {
  if (invalid && showError) {
    return 'is-invalid';
  }
  return '';
});

Vue.filter('StatusColor', function (transaction) {
  if (transaction != undefined && transaction.TransactionStatus != undefined) {
    switch (transaction.TransactionStatus.Code) {
      case '1': return "mb-2 mr-1 btn-secondary btn-sm";
      case '2': return "mb-2 mr-1 btn-warning btn-sm";
      case '11': case '14': return "mb-2 mr-1 btn-info btn-sm";
      case '3': return "mb-2 mr-1 btn-success btn-sm";
      case '4': break;
      case '6': case '12': case '5': case '19': return "mb-2 mr-1 btn-warning btn-sm";
      case '7': case '8': case '13': case'18': return "mb-2 mr-1 btn-danger btn-sm";
    }
  }
});

Vue.filter('StatusColorFraud', function (suspectTransaction) {
  if (suspectTransaction != undefined && suspectTransaction.SuspectTransactionStatus != undefined) {
    switch (suspectTransaction.SuspectTransactionStatus.Code) {
      case '1': return "mb-2 mr-1 btn-secondary btn-sm";
      case '2': return "mb-2 mr-1 btn-warning btn-sm";
      case '3': return "mb-2 mr-1 btn-success btn-sm";
      case '4': return "mb-2 mr-1 btn-danger btn-sm";
    }
  }
});

Vue.filter('StatusTextFraud', function (suspectTransaction) {
  if (suspectTransaction != undefined && suspectTransaction.SuspectTransactionStatus != undefined) {
    switch (suspectTransaction.SuspectTransactionStatus.Code) {
      case '1': return "Não analisada";
      case '2': return "Indefinida";
      case '3': return "Confiável";
      case '4': return "Fraude";
    }
  }
});

Vue.filter('StatusColorModal', function (transaction) {
  if (transaction != undefined && transaction.TransactionStatus != undefined) {
    switch (transaction.TransactionStatus.Code) {
      case '1': return "background-color:'#4e545b'";
      case '2': return "background-color:'#ffb400'";
      case '11': case '14': return "background-color:'#00b8d8'";
      case '3': return "background-color:'#09ab6f'";
      case '4': break;
      case '6': case '12': case '5': case '19': return "background-color:'#ffb400'";
      case '7': case '8': case '13': return "background-color:'#ea234d'";
    }
  }
});

Vue.filter('StatusText', function (transaction) {
  if (transaction != undefined && transaction.TransactionStatus != undefined) {
    switch (transaction.TransactionStatus.Code) {
      case '1': return "Pendente";
      case '2': return "Processamento";
      case '3': return "Autorizado";
      case '4': break;
      case '5': return "Em disputa";
      case '6': return "Devolvido";
      case '7': return "Baixado";
      case '8': return "Recusado";
      case '11': return "Liberado";
      case '12': return "Em Cancelamento";
      case '13': return "Chargeback";
      case '14': return "Pré-Autorizado";
      case '18': return "Abortado";
      case '19': return "Em Devolução";
    }
  }
});

Vue.filter('SubscriptionStatusText', function (subscription) {
  if (subscription != undefined && subscription.SubscriptionStatus != undefined) {
    switch (subscription.SubscriptionStatus.Code) {
      case '1': return "Ativa";
      case '2': return "Desativada";
      case '3': return "Atrasada";
      case '4': return "Pendente";
      case '5': return "Rejeitada";
      case '6': return "Inadimplente";
      case '7': return "Em Avaliação";
      case '8': return "Encerrada";
    }
  }
});

Vue.filter('SubscriptionStatusColor', function (subscription) {
  if (subscription != undefined && subscription.SubscriptionStatus != undefined) {
    switch (subscription.SubscriptionStatus.Code) {
      case '1': return "mb-2 mr-1 btn-success btn-sm";
      case '2': return "mb-2 mr-1 btn-secondary btn-sm";
      case '3': return "mb-2 mr-1 btn-warning btn-sm";
      case '4': return "mb-2 mr-1 btn-info btn-sm";
      case '5': return "mb-2 mr-1 btn-danger btn-sm";
      case '6': return "mb-2 mr-1 btn-danger btn-sm";
      case '7': return "mb-2 mr-1 btn-info btn-sm";
      case '8': return "mb-2 mr-1 btn-dark btn-sm";
    }
  }
});

Vue.filter('paymentMethodNameByCode', function (paymentMethod) {
  if(paymentMethod){
    switch (paymentMethod.Code) {
      case '1': return "Boleto Bancário";
      case '2': return "Cartão de Crédito";
      case '3': return (paymentMethod.Symbol == 'BTC' ? "Bitcoin" : paymentMethod.Symbol == 'LTC' ? "Litecoin" : "Bitcoin Cash");
      case '4': return "Cartão de Débito";
      case '6': return "Pix";
      default:  return "N/A";
    }
  }else{
    return "";
  }
});

Vue.filter('bankImgByCode', function (bankCode) {
  if (bankCode) {
    switch (bankCode) {
      case '001': return "@/assets/images/bank_0001.png";
      case '033': return "@/assets/images/bank_0033.png";
      case '041': return "@/assets/images/bank_0041.png";
      case '104': return "@/assets/images/bank_0104.png";
      case '237': return "@/assets/images/bank_0237.jpg";
      case '341': return "@/assets/images/bank_0341.png";
      case '422': return "@/assets/images/bank_0422.png";
      case '745': return "@/assets/images/bank_0745.png";
      case '102': return "@/assets/images/bank_0102.png";
      case '748': return "@/assets/images/bank_0748.png";
    }
  }
});


Vue.filter('paymentMethodIconByCode', function (paymentMethod, brand = "") {
  if(paymentMethod){
    const paymentMethodCode = _.isObject(paymentMethod) ? paymentMethod.Code : paymentMethod;
    switch (paymentMethodCode) {
      case '2':
      case '4':
        return brandIconByCode(brand);
      case '3': return "fab fa-bitcoin";
      case '1': return "fas fa-barcode";
      default:  return "";
    }
  }else{
    return "";
  }
});

Vue.filter('brandNameByCode', function (brand) {
  if(brand){
    return brandNameByCode(brand);
  }else{
    return "";
  }
});

Vue.filter('backgroundCheckStatus', function (backgroundCheck) {
  if(backgroundCheck){
    return backgroundCheckStatus(backgroundCheck);
  }else{
    return "";
  }
});

Vue.filter('brandIconByCode', function (brand) {
  if(brand){
    return brandIconByCode(brand);
  }else{
    return "";
  }
});

Vue.filter("currencyCrypto", function (value) {
  if (value == null || value == undefined || value.length == 0)
    return value;
  if (value) {
    let valueFloat = parseFloat(value);
    return valueFloat.toFixed(10).replace('.', ',');
  }
});

Vue.filter('TimeSince', function (data) {
  if (data != undefined && data != null && data != "") {
    var tTime = new Date(data);
    var cTime = new Date();
    var sinceMin = Math.round((cTime - tTime) / 60000);

    if (sinceMin == 0) {
      var sinceSec = Math.round((cTime - tTime) / 1000);

      if (sinceSec < 10)
        var since = 'agora há pouco';
      else
        var since = sinceSec + ' segundos';
    }
    else if (sinceMin == 1) {
      var sinceSec = Math.round((cTime - tTime) / 1000);

      if (sinceSec < 60)
        var since = sinceSec + ' segundos';
      else
        var since = '1 minuto';
    }
    else if (sinceMin < 60)
      var since = sinceMin + ' minutos';
    else if (sinceMin < 1440) {
      var sinceHr = Math.round(sinceMin / 60);

      if (sinceHr == 1)
        var since = '1 hora';
      else
        var since = sinceHr + ' horas';
    }
    else if (sinceMin > 1439 && sinceMin < 2880)
      var since = '1 dia';
    else {
      var sinceDay = Math.round(sinceMin / 1440);

      if (sinceDay > 30) {
        var sinceMonth = Math.round(sinceDay / 30);

        if (sinceMonth > 12) {
          var sinceYear = Math.round(sinceMonth / 12);

          if (sinceYear == 1) {
            var since = '1 ano';
          }
          else {
            var since = sinceYear + ' anos';
          }
        }
        else {
          if (sinceMonth == 1)
            var since = '1 mês';
          else
            var since = sinceMonth + ' meses';
        }
      }
      else {
        var since = sinceDay + ' dias';
      }

    }
    return since;
  }
  else {
    return "-";
  }
});


// WEBPACK FOOTER //
// ./src/utils/filters.js